import { Box, IconButton, MenuItem, Select, Tooltip } from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { BlobSortField, SortDirection } from "../utils/sort";

interface SortControlProps {
  field: BlobSortField;
  direction: SortDirection;
  onFieldChange: (field: BlobSortField) => void;
  onDirectionChange: (direction: SortDirection) => void;
}

const fieldOptions: { value: BlobSortField; label: string }[] = [
  { value: "name", label: "Name" },
  { value: "contentType", label: "Content Type" },
  { value: "size", label: "Size" },
  { value: "createdOn", label: "Created On" },
  { value: "lastModifiedOn", label: "Last Modified" },
  { value: "status", label: "Status" },
];

const SortControl = ({
  field,
  direction,
  onFieldChange,
  onDirectionChange,
}: SortControlProps) => {
  const handleFieldChange = (event: SelectChangeEvent) => {
    onFieldChange(event.target.value as BlobSortField);
  };

  const toggleDirection = () => {
    onDirectionChange(direction === "asc" ? "desc" : "asc");
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Select
        size="small"
        value={field}
        onChange={handleFieldChange}
        inputProps={{ "aria-label": "Sort by" }}
        sx={{ minWidth: 170 }}
      >
        {fieldOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            Sort by {option.label}
          </MenuItem>
        ))}
      </Select>
      <Tooltip title={direction === "asc" ? "Ascending" : "Descending"}>
        <IconButton
          size="small"
          onClick={toggleDirection}
          aria-label={`Sort direction: ${direction === "asc" ? "ascending" : "descending"}`}
        >
          {direction === "asc" ? (
            <ArrowUpwardIcon fontSize="small" />
          ) : (
            <ArrowDownwardIcon fontSize="small" />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default SortControl;
